import { DateTime as DT } from 'luxon';
import { safeJSONParse } from 'utils/helpers/safeParsing';
import { getPresetPeriodRange, periodRangeToMillis, type ReportPeriodType } from '../ReportDate/periodUtils';
import type { ReportDateFilterState } from './reportObjectsStorage';

const STORAGE_KEY = 'reportUsers.filters';

export type ReportUsersViewMode = 'summary' | 'detail';
export type ReportUsersObjectFilter = 'all' | 'closed';

export interface ReportUsersFiltersState extends ReportDateFilterState {
    viewMode: ReportUsersViewMode;
    objectFilter: ReportUsersObjectFilter;
}

const createDefaultFilters = (): ReportUsersFiltersState => {
    const { start, end } = getPresetPeriodRange('month', DT.now());
    return {
        period: 'month',
        dates: periodRangeToMillis(start, end),
        customRange: null,
        viewMode: 'summary',
        objectFilter: 'all',
    };
};

export const loadReportUsersFilters = (): ReportUsersFiltersState => {
    const saved = safeJSONParse(sessionStorage.getItem(STORAGE_KEY)) as Partial<ReportUsersFiltersState> | null;
    if (!saved?.dates?.[0] || !saved?.dates?.[1]) {
        return createDefaultFilters();
    }

    const period: ReportPeriodType =
        saved.period === 'month' || saved.period === 'quarter' || saved.period === 'year' || saved.period === 'custom'
            ? saved.period
            : 'month';

    return {
        period,
        dates: [saved.dates[0], saved.dates[1]],
        customRange:
            saved.customRange?.[0] && saved.customRange?.[1]
                ? [saved.customRange[0], saved.customRange[1]]
                : null,
        viewMode: saved.viewMode === 'detail' ? 'detail' : 'summary',
        objectFilter: saved.objectFilter === 'closed' ? 'closed' : 'all',
    };
};

export const saveReportUsersFilters = (state: ReportUsersFiltersState): void => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};
